module.exports = __webpack_public_path__ + "img/icon-hamburger.a6e0081a.svg";